<!-- Product Listing Page - Modern E-commerce Design -->
<div class="product-listing-page">

  <!-- Global Header -->
  <div class="global-header">
    <div class="header-content">
      <div class="header-links">
        <a href="/home" class="header-link">Home</a>
        <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Electronics" class="header-link">Electronics</a>
        <a href="/customer-category-list-view?_id=66487cc9e8befc51f80542f7&categoryName=Beauty" class="header-link">Beauty</a>
        <a href="/customer-category-list-view?_id=66487c39e8befc51f80542e7&categoryName=Baby%20and%20Toddler" class="header-link">Baby Toddler</a>
        <a href="/customer-category-list-view?_id=66487b04e8befc51f80542d9&categoryName=Appliances" class="header-link">Appliances</a>
        <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Home%20Decor%20Products" class="header-link">Home Decor</a>
        <div class="see-more-dropdown">
          <button class="see-more-btn">See More</button>
          <div class="dropdown-content">
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Fashion" class="dropdown-link">Fashion</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Home%20%26%20Garden" class="dropdown-link">Home & Garden</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Sports" class="dropdown-link">Sports</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Books" class="dropdown-link">Books</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Camping%20and%20Outdoor" class="dropdown-link">Camping and Outdoor</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Clothing%20and%20Shoes" class="dropdown-link">Clothing and Shoes</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Dairy%20Products" class="dropdown-link">Dairy Products</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Fruits%20%26%20Vegetable" class="dropdown-link">Fruits & Vegetable</a>
            <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=Health%20Products" class="dropdown-link">Health Products</a>
          </div>
        </div>
      </div>
      <a href="/customer-category-list-view?_id=66487e18e8befc51f8054306&categoryName=All" class="all-categories-btn">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="7" height="7" fill="white"/>
          <rect x="14" y="3" width="7" height="7" fill="white"/>
          <rect x="3" y="14" width="7" height="7" fill="white"/>
          <rect x="14" y="14" width="7" height="7" fill="white"/>
        </svg>
        All Categories
      </a>
    </div>
  </div>
  <!-- Breadcrumb Navigation -->
  <div class="breadcrumb-section">
    <div class="breadcrumb-container">
      <a href="/home" class="breadcrumb-link">Home</a>
      <span class="breadcrumb-separator">/</span>
      <span class="breadcrumb-link">Products</span>
      <span class="breadcrumb-separator">/</span>
      <span class="breadcrumb-current">All Products</span>
    </div>
  </div>

  <!-- Red Banner Section -->
  <div class="red-banner">
    <div class="banner-content">
      <h1 class="banner-title">All Products</h1>
      <p class="banner-subtitle">Discover amazing products at unbeatable prices</p>
    </div>
  </div>

  <!-- Location Loading Indicator -->
  <div *ngIf="isLoading && !bannerData?.length" class="location-loading">
    <div class="loading-spinner"></div>
    <p>Getting your location to show products available in your area...</p>
  </div>

  <!-- Product Grid -->
  <div class="product-grid-section">
    <div class="product-grid">
      <!-- Product Cards -->
      <ng-container *ngIf="bannerData?.length">
        <div
          class="product-card"
          *ngFor="
            let item of bannerData
              | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: currentPage,
                    totalItems: totalItems
                  };
            let i = index
          "
          (click)="navigateToViewProduct(item?._id)"
          (mouseenter)="debugProductData(item)"
        >
          <div class="product-image">
            <img [src]="item?.thumbnail" [alt]="item?.productName" />
            <div class="discount-badge" *ngIf="getOriginalPrice(item) && getOriginalPrice(item) !== getDisplayPrice(item)">
              {{ getDiscountPercentage(item) }}% OFF
            </div>
            <button class="wishlist-btn" (click)="toggleWishlist(item?._id, $event)" [class.active]="item?.isLike">
              <i class="fa fa-heart-o"></i>
            </button>
          </div>
          <div class="product-info">
            <div class="brand-name" *ngIf="item?.brand && !item?.subCategoryId?.subCategoryName">
              {{ item?.brand }}
            </div>
            <div class="product-subcategory mb-1" *ngIf="item?.subCategoryId?.subCategoryName">
              {{ item?.subCategoryId?.subCategoryName }}
            </div>
            <h3 class="product-name">{{ item?.productName }}</h3>
            <p class="product-description">{{ item?.description || 'Premium quality product with modern design and excellent features.' }}</p>
            <div class="price-section">
              <span class="current-price">{{ getDisplayPrice(item) }}</span>
              <span class="original-price" *ngIf="getOriginalPrice(item)">{{ getOriginalPrice(item) }}</span>
            </div>
            <div class="cta-row">
              <button class="add-to-cart-btn">
                <i class="fa fa-shopping-cart"></i>
                ADD TO CART
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      
      <!-- Loading State -->
      <ng-container *ngIf="!bannerData?.length && !isLoading">
        <div class="product-card loading-card" *ngFor="let item of length(12)">
          <div class="loading-image">
            <div class="skeleton-loader"></div>
          </div>
          <div class="loading-title">
            <div class="skeleton-text"></div>
          </div>
        </div>
      </ng-container>
      <!-- No Data State -->
      <div *ngIf="isLoading" class="no-data-state">
        <p>No Product Available...</p>
      </div>
    </div>
  </div>
  <!-- Pagination -->
  <div class="pagination-section" *ngIf="totalItems > pageSize">
    <div class="pagination-controls">
      <button 
        class="pagination-btn prev-btn" 
        [disabled]="currentPage === 1"
        (click)="goToPage(currentPage - 1)"
        [class.disabled]="currentPage === 1">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      
      <!-- Dynamic page numbers -->
      <button 
        *ngFor="let page of getPageNumbers()" 
        class="pagination-btn page-btn" 
        [class.active]="page === currentPage"
        (click)="goToPage(page)">
        {{ page }}
      </button>
      
      <button 
        class="pagination-btn next-btn" 
        [disabled]="currentPage === getTotalPages()"
        (click)="goToPage(currentPage + 1)"
        [class.disabled]="currentPage === getTotalPages()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

</div>
